import { FC, useState } from 'react';

import { ChakraAutocomplete } from 'app/components/Core';
import { DDL, Option } from 'types/general.types';
import { ChakraAutocompleteProps } from 'app/components/Core/ChakraAutocomplete/types';

interface AudioReleaseVersionSelectionProps {
  versionTypesDDL: DDL;
  audioReleaseVersion: string;
  onChange: ChakraAutocompleteProps<Option>['onChange'];
}

export const AudioReleaseVersionSelection: FC<AudioReleaseVersionSelectionProps> = ({
  versionTypesDDL,
  audioReleaseVersion = 'AlbumVersion',
  onChange,
}) => {
  const options = Object.values(versionTypesDDL).map((value) => ({
    title: value.name,
    value: value.key,
  }));

  const [value, setValue] = useState<Option | null | undefined>(
    options.find(({ value }) => value === audioReleaseVersion)
  );

  return (
    <ChakraAutocomplete<Option>
      label="Version Type"
      options={options}
      getOptionLabel={(option) => option?.title || ''}
      value={value}
      onChange={(option) => {
        setValue(option);
        onChange?.(option);
      }}
    />
  );
};
